import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent'
import TableEPL from '../TableEPL/TableEPL'
import { Grid, Stack } from '@mui/material'
import { showToast } from '../../../../components/ui'

const TabCostDiscountConsignee = (props) => {
  const title = 'Cost Discount Consignee'
  const contactTypeName = 'Discount Consignee'
  const contactTypeId = 9
  const income = false

  const handleAdd = () => {
    if (props.shipmentNo !== '') {
      props.handleAdd(title, contactTypeName, contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Please Select Shipment Number First!' });
    }
  }

  const handleEdit = () => {
    if (props.selectedDetailCostDiscountConsignee.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleEdit(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleConvert = () => {
    if (props.selectedDetailCostDiscountConsignee.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleConvert(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleDoubleClick = () => {
    handleEdit()
  }

  const handleDelete = () => {
    if (props.selectedDetailCostDiscountConsignee.bookingDetailId === 0) {
      props.handleDelete(contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Can\'t Delete This Data!' });
    }
  }

  return (
    <div className='rounded-10'>
      <TableEPL
        key={7}
        isReadOnly={props.isReadOnly}
        dataList={props.CostDiscountConsigneeList}
        ignoreAccess={props.ignoreAccess}
        setDataList={props.setCostDiscountConsigneeList}
        setSelectedDetail={props.setSelectedDetailCostDiscountConsignee}
        selectedDetail={props.selectedDetailCostDiscountConsignee}
        handleDoubleClick={handleDoubleClick}
        contactTypeName={contactTypeName}
        ttlUsd={props.estCostUSDDiscountConsignee}
        ttlIdr={props.estCostIDRDiscountConsignee}
        totalSData={props.totalCostSDiscountConsignee}
        totalNData={props.totalCostNDiscountConsignee}
        key1={7}
        key2={7}
        type={2}
        openClose={props.openCloseCRC}
        setOpenClose={props.setOpenCloseCRC}
        openClose2={props.openCloseCRC2}
        setOpenClose2={props.setOpenCloseCRC2}
        dataDetail={props.dataDetail}
        setDataDetail={props.setDataDetail}
        countSum={props.countSum}
        countTotalData={props.countTotalData}
      />

      <Grid container item direction="row" className='mt-3'>
        <Grid item xs={12}>
          <Stack direction={'row'} spacing={'10px'}>
            {ButtonComponent.AddButton(handleAdd, '', props.isReadOnly)}
            {ButtonComponent.EditButton(handleEdit, '', props.isReadOnly)}
            {ButtonComponent.DeleteButton(handleDelete, '', props.isReadOnly)}
            {ButtonComponent.ConvertButton(handleConvert, props.isReadOnly, true)}
          </Stack>
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(TabCostDiscountConsignee)